/* eslint-disable */
// AUTO-GENERATED - DO NOT EDIT
import { z, testRegex } from '@talbenmoshe/atlas-api/client';
export { toSnakeCase } from './caseTransform.js';
// ============ Component Validation Schemas ============
export const ServiceStatusResponseSchema = z.object({
    service: z.string(),
    databaseValue: z.string(),
}).loose();
export const StartEmailSignInRequestSchema = z.object({
    email: z.email().max(254),
}).strict();
export const EmailSignInStartedResponseSchema = z.object({
    resendAvailableAt: z.iso.datetime(),
    resendAvailableInSeconds: z.number().int().min(0),
}).loose();
export const TooManyCodesErrorSchema = z.object({
    reason: z.literal('too-many-codes'),
    resendAvailableAt: z.iso.datetime(),
    resendAvailableInSeconds: z.number().int().min(0),
}).loose();
export const VerifyEmailSignInRequestSchema = z.object({
    email: z.email().max(254),
    code: z.string().refine((val) => testRegex('^[0-9]{6}$', val), { message: 'Invalid format' }),
    returnTo: z.string().max(8192).optional(),
}).strict();
export const EmailSignInVerifiedResponseSchema = z.object({
    redirectTo: z.url(),
}).loose();
export const SignInRefusedErrorSchema = z.object({
    reason: z.enum(['wrong-code', 'code-expired', 'too-many-attempts']),
    attemptsLeft: z.number().int().min(1).max(4).optional(),
    resendAvailableAt: z.iso.datetime(),
    resendAvailableInSeconds: z.number().int().min(0),
}).loose();
export const OpenIdConfigurationSchema = z.object({
    issuer: z.string(),
    jwks_uri: z.string(),
    authorization_endpoint: z.string(),
    token_endpoint: z.string(),
    response_types_supported: z.array(z.string()),
    subject_types_supported: z.array(z.string()),
    id_token_signing_alg_values_supported: z.array(z.string()),
}).loose().transform((data) => ({
    issuer: data.issuer,
    jwksUri: data.jwks_uri,
    authorizationEndpoint: data.authorization_endpoint,
    tokenEndpoint: data.token_endpoint,
    responseTypesSupported: data.response_types_supported,
    subjectTypesSupported: data.subject_types_supported,
    idTokenSigningAlgValuesSupported: data.id_token_signing_alg_values_supported,
}));
export const JsonWebKeySchema = z.object({
    kty: z.literal('RSA'),
    n: z.string(),
    e: z.string(),
    alg: z.literal('RS256'),
    use: z.literal('sig'),
    kid: z.string(),
}).loose();
export const JsonWebKeySetSchema = z.object({
    keys: z.array(JsonWebKeySchema),
}).loose();
export const NotSignedInErrorSchema = z.object({
    reason: z.literal('not-signed-in'),
}).loose();
// ============ Request Schemas ============
export const GetTripOsIdentityStatusRequestSchema = z.object({}).loose();
export const GetOpenIdConfigurationRequestSchema = z.object({}).loose();
export const GetJwksRequestSchema = z.object({}).loose();
export const RenewSessionRequestSchema = z.object({}).loose();
export const SignOutRequestSchema = z.object({}).loose();
// ============ Response Schemas ============
export const ServiceStatusResponseResponseSchema = ServiceStatusResponseSchema;
export const EmailSignInStartedResponseResponseSchema = EmailSignInStartedResponseSchema;
export const EmailSignInVerifiedResponseResponseSchema = EmailSignInVerifiedResponseSchema;
export const OpenIdConfigurationResponseSchema = OpenIdConfigurationSchema;
export const JsonWebKeySetResponseSchema = JsonWebKeySetSchema;
//# sourceMappingURL=TripOsIdentityAPISchemas.js.map